if (!customElements.get('terms-conditions')) {
  customElements.define(
    'terms-conditions',
    class TermsConditions extends HTMLElement {
      constructor() {
        super();
        const checkoutBtn = document.querySelector('#main-cart-footer #checkout');
        checkoutBtn.dataset.awaitingCheckoutConditions = +checkoutBtn.dataset.awaitingCheckoutConditions || 0;
        checkoutBtn.dataset.awaitingCheckoutConditions = +checkoutBtn.dataset.awaitingCheckoutConditions + 1;
        checkoutBtn.disabled = true;

        const termsAndConditions = document.querySelector('#terms_and_conditions');

        termsAndConditions.addEventListener('change', (e) => {
          if(termsAndConditions.checked === true) {
            checkoutBtn.dataset.awaitingCheckoutConditions = +checkoutBtn.dataset.awaitingCheckoutConditions - 1;

            if(+checkoutBtn.dataset.awaitingCheckoutConditions === 0) {
              checkoutBtn.disabled = false;
            }
          } else {
            checkoutBtn.dataset.awaitingCheckoutConditions = +checkoutBtn.dataset.awaitingCheckoutConditions + 1;
            checkoutBtn.disabled = true;
          }
        });
      }
    }
  );
}
